import { render, staticRenderFns } from "./SiteDetails.vue?vue&type=template&id=22679d9e&"
import script from "./SiteDetails.vue?vue&type=script&lang=js&"
export * from "./SiteDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports